<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="qe_code,qe_prodcode,qe_prodname"
      placeholder="输入单据编号、产品进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/qc/qe/' + item.id"
      >
        <div class="weui-cell__bd">
          <p>{{ item.qe_prodcode }}</p>
          <p class="list-item-muted">{{ item.qe_code }}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{ item.qe_prodname }}</p>
          <span v-if="item.qe_result == null && item.qc_result == '不达标'"
            class="list-item-status warning"
            >待处理</span
          >
          <span v-else  class="list-item-status">已处理</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{ items.length }}条</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/qc/makeQe/list",
      filters: [
        {
          type: "date",
          name: "qc_date",
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待处理",
              condition: "qe_result is null and qc_result = '不合格'",
            },
            {
              value: 2,
              label: "已处理",
              condition: "qe_result is not null",
            },
          ],
        },
      ],
    };
  },
};
</script>